import { render, staticRenderFns } from "./FabAtalhos.vue?vue&type=template&id=ddc9f73e&scoped=true"
import script from "./FabAtalhos.vue?vue&type=script&lang=js"
export * from "./FabAtalhos.vue?vue&type=script&lang=js"
import style0 from "./FabAtalhos.vue?vue&type=style&index=0&id=ddc9f73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc9f73e",
  null
  
)

export default component.exports